export default "__VITE_ASSET__IUDclwTl__"